(function () {
  document.querySelectorAll('[data-testimonials]').forEach(function (root) {
    var track = root.querySelector('[data-testimonials-track]');
    var cards = root.querySelectorAll('[data-testimonials-card]');
    var prevBtn = root.querySelector('[data-testimonials-prev]');
    var nextBtn = root.querySelector('[data-testimonials-next]');

    // Scroll-reveal: fade + rise up each card as it enters the viewport
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
      );
      cards.forEach(function (card) {
        observer.observe(card);
      });
    } else {
      // Fallback: no IntersectionObserver support, just show everything
      cards.forEach(function (card) {
        card.classList.add('is-visible');
      });
    }

    // Arrow buttons scroll the track by roughly one card width
    if (track && prevBtn && nextBtn) {
      var scrollByCard = function (direction) {
        var card = track.querySelector('[data-testimonials-card]');
        var amount = card ? card.getBoundingClientRect().width + 20 : 300;
        track.scrollBy({ left: direction * amount, behavior: 'smooth' });
      };
      prevBtn.addEventListener('click', function () {
        scrollByCard(-1);
      });
      nextBtn.addEventListener('click', function () {
        scrollByCard(1);
      });
    }
  });
})();